<template>
  <div class="transaction-page">
    <el-row
      class="transaction-page__row"
      type="flex"
      v-if="
        stateTransactions.transactionsList &&
          stateTransactions.transactionsList.length > 0
      "
    >
      <el-col>
        <p class="page-form-title">Transaction Page</p>
        <p class="page-form-tip">See the transaction detail.</p>
        <div
          v-if="
            stateTransactions.transactionsList &&
              stateTransactions.transactionsList.length > 0
          "
        >
          <el-card
            v-for="(item, index) in stateTransactions.transactionsList"
            :key="index"
          >
            <div
              v-if="
                item.payload.reducedPayload.commandsList &&
                  item.payload.reducedPayload.commandsList.length > 0
              "
            >
              <div
                v-for="(command, i) in item.payload.reducedPayload.commandsList"
                :key="i"
              >
                <el-table
                  :data="JSONToArray(command)"
                  stripe
                  border
                  style="width: 100%; margin-bottom: 20px;"
                >
                  <el-table-column prop="key" width="120">
                    <template slot-scope="scope">
                      {{ scope.row.key }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="value">
                    <template slot-scope="scope">
                      {{ scope.row.value }}
                    </template>
                  </el-table-column>
                </el-table>
                <p class="page-form-tip">Raw Data:</p>
                <json-view :data="JSONFilter(command)" />
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-row class="transaction-page__row" type="flex" v-else>
      <el-col>
        <el-card>
          <div class="transaction-page__information">
            <b>No Data.</b>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { filters as dateFilters } from '@util/date-format'
import jsonView from 'vue-json-views'
import _ from 'lodash'

export default {
  name: 'transaction-page',

  data() {
    return {}
  },

  filters: {
    ...dateFilters
  },

  components: {
    jsonView
  },

  methods: {
    ...mapActions(['getTransactions']),
    JSONFilter(json) {
      const deep = _.cloneDeep(json)
      Object.keys(deep).forEach(key => {
        !deep[key] && delete deep[key]
        deep?.transferAsset?.assetId?.includes('log') &&
          delete deep.transferAsset.assetId
        deep[key] &&
          Object.keys(deep[key]).forEach(i => {
            deep[key][i] = this.formatValue(deep[key][i])
          })
      })
      if (deep?.transferAsset) {
        const orderType = deep?.transferAsset?.description[0]
        if (orderType !== '4') {
          deep.transferAsset.source_id = deep?.transferAsset?.description.split(
            ','
          )[1]
        } else {
          deep.transferAsset.amount = deep?.transferAsset?.description.split(
            ','
          )[1]
          deep.transferAsset.currency_id = deep?.transferAsset?.description.split(
            ','
          )[2]
        }
        delete deep.transferAsset.description
        deep.transferAsset.source_type = this.formatSourceType(orderType)
      }
      return deep
    },
    JSONToArray(json) {
      const deep = _.cloneDeep(this.JSONFilter(json))
      const array = []
      deep?.transferAsset &&
        Object.keys(deep.transferAsset).forEach(key => {
          array.push({
            key: key,
            value: deep?.transferAsset[key]
          })
        })
      return array
    },
    formatValue(value) {
      value = value.split('#')[0]
      value = value.split('@')[0]
      return value
    },
    formatSourceType(type) {
      switch (type) {
        case '1':
          return 'Deposit'
        case '2':
          return 'Withdraw'
        case '3':
          return 'Transaction'
        case '4':
          return 'Order Create'
        case '5':
          return 'Order Pay'
        case '6':
          return 'Order Refund'

        default:
          return 'Transaction'
      }
    }
  },

  computed: mapState({
    stateTransactions: state => state.Account.transactions
  }),

  created() {
    this.getTransactions({ tx_hashes: this.$route.query.tx_hashes }).catch(
      err => {
        this.$alert(err.message, 'ERROR', {
          type: 'error'
        })
      }
    )
  }
}
</script>

<style lang="scss">
.transaction-page__row {
  .el-table th {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.transaction-page__row {
  padding: 2rem;
}

.transaction-page__information {
  margin: 1rem;
  b {
    margin-right: 2rem;
  }
}

.el-table th {
  display: none;
}
</style>
